import { useEffect, useState } from "react";

export default function useScreen() {
  const [heightScreen, setHeightScreen] = useState<number>(
    window.screen.height
  );

  const handleSetHeightScreen = () => {
    const body = document.querySelector("body");
    if (body) {
      setHeightScreen(body.clientHeight);
    }
  };
  useEffect(() => {
    handleSetHeightScreen();
    window.addEventListener("resize", handleSetHeightScreen);

    return () => {
      window.removeEventListener("resize", handleSetHeightScreen);
    };
  }, []);
  return heightScreen;
}

export const SCREEN_LIST = {
  screenHeight1: 736,
  screenHeight2: 670,
  screenHeight3: 600,
};